import "../../styles/Cards.css";
import Navbar from "../../components/Navbar";
import TopNavbar2side from "../../components/TopNavbar2side";
import "../../styles/Buttons.css";
import "../../styles/Containers.css";
import "../../styles/Colors.css";
import GoToTop from "../../components/GoToTop";
import { useEffect, useState } from "react";
import LoadingPage from "../../components/LoadingPage";
import GroceryEmptyState from "./components/GroceryEmptyState";
import { useFetch } from "../../custom/api";
import { RWebShare } from "react-web-share";
import Accordion from "../../components/Accordion";
import DateModal from "./components/DateModal";

const Grocery = () => {
  const { myFetch } = useFetch();
  const isLoggedIn = !!localStorage.getItem("token");
  const [groceryList, setGroceryList] = useState(null);
  const [rand, setRand] = useState(null);
  const [shareText, setShareText] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [emptyDate1Error, setEmptyDate1Error] = useState("");
  const [emptyDate2Error, setEmptyDate2Error] = useState("");

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEmptyDate1Error(false);
    setEmptyDate2Error(false);
  };

  function createShareText(groceryList) {
    let finalText = "لیست‌های خرید فودپلنر\n\n";
    groceryList.map((item, index) => {
      finalText += "🧾";
      finalText +=
        item.items[0].grocery_list_name === null
          ? `لیست خرید ${index + 1}`
          : item.items[0].grocery_list_name;
      finalText += "\n";
      item.items.map((elem) => {
        finalText += `${elem.item_name}: ${elem.item_amount} ${elem.unit_name}\n`;
      });

      finalText += "\n\n";
    });
    finalText += "\n\n\n";
    setShareText(finalText);
  }

  // const [error, setError] = useState("");

  useEffect(() => {
    if (!isLoggedIn) return;
    const fetchData = async () => {
      const resp = await myFetch("grocery", { method: "GET" });
      const r = await resp.json();
      setGroceryList(r);
      createShareText(r);
    };
    fetchData();
  }, [rand]);

  if (!isLoggedIn) {
    return <GroceryEmptyState variant="guest" />;
  }

  if (groceryList !== null && Object.keys(groceryList).length === 0) {
    return (
      <>
        <GroceryEmptyState variant="empty" onCtaClick={handleOpenModal} />
        <DateModal
          showModal={showModal}
          handleCloseModal={handleCloseModal}
          loading={loading}
          emptyDate1Error={emptyDate1Error}
          emptyDate2Error={emptyDate2Error}
          setRand={setRand}
        ></DateModal>
      </>
    );
  }

  return (
    <div className="paddingButtom80 grey-background">
      {groceryList === null ? (
        <LoadingPage />
      ) : (
        <>
          <RWebShare
            data={{
              text: shareText,
              url: "https://foodplanner.ir",
              title: "🥬🥩🛒 لیست خرید",
            }}
            // onClick={() => console.log("shared successfully!")}
          >
            <TopNavbar2side
              title="لیست خرید"
              sideTitle="اشتراک گذاری"
              buttonHref={[""]}
              buttonIcon={["icon-iconshare"]}
              classN={["rectangle"]}
            />
          </RWebShare>

          <div>
            {groceryList.map((item, index) => {
              return (
                <div key={index}>
                  <Accordion
                    title={
                      item.items[0].grocery_list_name === null
                        ? `لیست خرید ${index + 1}`
                        : item.items[0].grocery_list_name
                    }
                    content={item.items}
                    listId = {item.name}
                    groceryList = {groceryList}
                    setGroceryList= {setGroceryList}
                  />
                </div>
              );
            })}
            <div className="marginTop5 marginSide10">
              <button onClick={handleOpenModal} className="subject-1">
                + اضافه کردن لیست خرید از تقویم
              </button>
            </div>
            <DateModal
              showModal={showModal}
              handleCloseModal={handleCloseModal}
              loading={loading}
              emptyDate1Error={emptyDate1Error}
              emptyDate2Error={emptyDate2Error}
              setRand={setRand}
            ></DateModal>
          </div>
        </>
      )}

      <Navbar />

      <GoToTop />
    </div>
  );
};

export default Grocery;
